import { render, staticRenderFns } from "./ThreadParticipantsModal.vue?vue&type=template&id=1b73739f&scoped=true&"
import script from "./ThreadParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./ThreadParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./ThreadParticipantsModal.vue?vue&type=style&index=0&id=1b73739f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73739f",
  null
  
)

export default component.exports